module.exports = __webpack_public_path__ + "img/icon-upload.080b01e0.svg";